import { Form, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

// Import dos contextos
import { useAppContext } from "../../../../../context/AppContext";
import { useWebsite } from "../Context/WebSiteContext";

// Imports dos components
import HeroClassic from "./Components/Templateclassic/HeroClassic";
import GalleryClassic from "./Components/Templateclassic/GalleryClassic";
import AboutClassic from "./Components/Templateclassic/AboutClassic";
import FormClassic from "./Components/Templateclassic/FormClassic";
import StatusObraClassic from "./Components/Templateclassic/StatusObraClassic";
import FooterClassic from "./Components/Templateclassic/FooterClassic";
import BannerConfirm from "./Components/BannerConfirm";
import SidebarConfig from "./Components/Sidebarconfig";
import BannerPreview from "./Components/BannerPreview";
import MapClassic from "./Components/Templateclassic/MapClassic";
import NavbarClassic from "./Components/Templateclassic/NavbarClassic";

// Import do CSS
import "primeicons/primeicons.css";
import "./Styles/TemplateClassic.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const TemplateClassic = ({ config, hideSidebar }) => {
  const { id } = useParams();
  const location = useLocation();
  const context = useAppContext();
  const { formData, handlePublish, handleCancel } = useWebsite();

  const enterprise_id = location.state?.enterprise_id;

  const mergedConfig = { ...config, ...formData };
  const finalOrderedSections = Array.isArray(formData?.orderedSections)
    ? formData.orderedSections
    : Array.isArray(formData?.orderedsections)
    ? formData.orderedsections
    : Array.isArray(config.orderedSections)
    ? config.orderedSections
    : config.orderedsections;

  function isSectionActive(sectionName) {
    const sectionsFormData = formData?.sections || {};
    const sectionsConfig = config?.sections || {};
    if (sectionsFormData.hasOwnProperty(sectionName))
      return !!sectionsFormData[sectionName];
    if (sectionsConfig.hasOwnProperty(sectionName))
      return !!sectionsConfig[sectionName];
    return true;
  }

  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass
  } = useAppContext();

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    return () => {
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  if (!config) return <div>Configurações não carregadas</div>;

  return (
    <>
      {!hideSidebar && (
        <SidebarConfig enterprise_id={location.state?.enterprise_id} />
      )}
      {!hideSidebar && <BannerConfirm />}
      <div className="template-classico">
        {/* <div>hideSidebar: {String(hideSidebar)}</div> */}
        {hideSidebar && (
          <BannerPreview
            onEdit={() => (window.location.href = `/template/${id}`)}
          />
        )}

        {Array.isArray(finalOrderedSections) &&
          finalOrderedSections.map((sectionName, index) => {
            if (!isSectionActive(sectionName)) return null;
            switch (sectionName) {
              case "Menu":
                return (
                  <NavbarClassic
                    key={index}
                    config={mergedConfig}
                    hideSidebar={hideSidebar}
                  />
                );
              case "Cabeçalho":
                return <HeroClassic key={index} config={mergedConfig} />;
              case "Galeria":
                return <GalleryClassic key={index} config={mergedConfig} />;
              case "Sobre":
                return <AboutClassic key={index} config={mergedConfig} />;
              case "Map":
                return (
                  <MapClassic
                    key={index}
                    config={mergedConfig}
                    enterprise_id={enterprise_id}
                  />
                );
              case "Formulario":
                return (
                  <FormClassic
                    key={index}
                    config={mergedConfig}
                    formData={formData}
                    handlePublish={handlePublish}
                    handleCancel={handleCancel}
                  />
                );
              case "Status":
                return <StatusObraClassic key={index} config={mergedConfig} />;
              case "Rodapé":
                return <FooterClassic key={index} config={mergedConfig} />;
              default:
                return null;
            }
          })}
      </div>
    </>
  );
};

export default TemplateClassic;
